<template>
    <div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="categoryId"
            search-url="/category/listByType?type=FARMING_PROCESS"
            create-url="/category/save"
            delete-url="/category/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :isPagination="false"
            deleteMulti="false"
        >
        </c-search-form>
        <farming-process-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import FarmingProcessCreate from "./FarmingProcessCreate.vue";
import axios from "axios";

export default {
    name: "warehouse",
    components: { FarmingProcessCreate, CSearchForm },
    data: () => {
        return {
            formName: "Quy trình nuôi",
            category: null,
            visibleCreateDialog: false,
            timeReload: 0,
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "categoryCode",
                    text: "Mã quy trình",
                    sortable: false,
                    search: false,
                    headerStyle: "text-align:left",
                },
                {
                    value: "categoryName",
                    text: "Tên quy trình",
                    sortable: false,
                    search: false,
                    headerStyle: "text-align:left",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    sortable: false,
                    compound: true,
                    width: "10%",
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        
    },

    methods: {
        openCreateDialog: function (item = null) {
            this.category = item;
            this.visibleCreateDialog = true;
        },
        closeCreateDialog: function () {
            this.category = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },
    },

    destroyed() {},
};
</script>
